<nz-form-item [formGroup]="formConfig.parentForm">
	<nz-form-label [nzSpan]="6">{{ schema?.title || schemaKey | translate }}</nz-form-label>
		<nz-form-control [nzSpan]="18" [nzErrorTip]="errorTemplate">
			<input *ngIf="formConfig.viewOnly"
				nzBorderless nz-input formControlName="{{ key }}"
				class="ft-view" [type]="format"
				(ngModelChange)="setValid($event)"
			/>
			<input *ngIf="!formConfig.viewOnly"
				nz-input formControlName="{{ key }}" [required]="required"
				class="ft-edit" [type]="format"
				[minlength]="schema?.minLength" [maxlength]="schema?.maxLength"
				[pattern]="schema?.pattern"
				autocomplete="new-password" spellcheck="false"
				(ngModelChange)="setValid($event)"
			/>
			<ng-template #errorTemplate let-control>
				<span *ngIf="control.hasError('validation')">{{control.errors['validation']}}&nbsp;</span>
				<span *ngIf="control.hasError('required')">{{ 'form.input.required' | translate: {itemName : schema?.title || schemaKey | translate } }}&nbsp;</span>
				<span *ngIf="control.hasError('minlength')">{{'form.input.minlength' | translate: control.errors['minlength'] }}&nbsp;</span>
				<span *ngIf="control.hasError('pattern') && schema | hasPatternDescription">{{schema['patternDescription']}}&nbsp;</span>
			</ng-template>
	</nz-form-control>
</nz-form-item>
